/* eslint-disable max-classes-per-file */
class BrazeMessage {
    constructor(message, appboyInstance) {
        this.message = message;
        this.appboy = appboyInstance;
    }
    logImpression() {
        this.appboy.logInAppMessageImpression(this.message);
    }
    logButtonClick(internalButtonId) {
        const button = new this.appboy.InAppMessageButton(`Button: ID ${internalButtonId}`, undefined, undefined, undefined, undefined, undefined, internalButtonId);
        this.appboy.logInAppMessageButtonClick(button, this.message);
    }
    get extras() {
        return this.message.extras;
    }
}
class BrazeMessages {
    constructor(appboyInstance) {
        this.appboy = appboyInstance;
        this.bannerMessage = this.getMessageForSlot('Banner');
        this.endOfArticleMessage = this.getMessageForSlot('EndOfArticle');
    }
    getMessageForSlot(targetSlotName) {
        return new Promise((resolve) => {
            const callback = (m) => {
                // Cast this as we only ever expect it to be an InAppMessage
                const message = m;
                const { extras } = message;
                if (extras &&
                    extras.slotName &&
                    extras.slotName === targetSlotName) {
                    resolve(new BrazeMessage(message, this.appboy));
                }
            };
            this.appboy.subscribeToInAppMessage(callback);
        });
    }
    getMessageForBanner() {
        return this.bannerMessage;
    }
    getMessageForEndOfArticle() {
        return this.endOfArticleMessage;
    }
}
export { BrazeMessages, BrazeMessage };
